"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateJson = void 0;
const Jsonschema = __importStar(require("jsonschema"));
const validateJson = (input, schema, description, logger) => {
    const validationResult = Jsonschema.validate(input, schema);
    if (validationResult.valid) {
        logger.verbose(`${description} json is valid`);
    }
    else {
        const error = new Error();
        const errorAt = validationResult.errors
            .map((validationError, index) => `\n${index}. error at ${JSON.stringify(validationError.instance)}`)
            .reduce((previous, current) => (previous += current));
        error.message = `${description} json is invalid${errorAt}`;
        throw error;
    }
};
exports.validateJson = validateJson;
//# sourceMappingURL=json-validator.js.map